module.exports = __webpack_public_path__ + "img/b_8.383e99c6.jpg";